import React from "react";
import ArrowNext from "../../assets/icons/arrownext.svg";
import CompanyNotFoundBg from "../../assets/images/bg-texture-tr.png";
import { useSelector, useDispatch } from "react-redux";
import { setCompany } from "../../store/search/searchSlice";
import { Link } from "react-router-dom";

export const NotFoundCompany = ({ }) => {
  const dispatch = useDispatch();
  // TIP-556 — carry the failed search into the order form so the company name
  // and country arrive pre-filled. Link state (not redux) because router state
  // is persisted in history.state and survives a refresh on the target page.
  const { searchQuery, countryData } = useSelector((state) => state.search);

  const handleSwitch = () => {
    dispatch(setCompany(null));
  };

  return (
    <div className="rounded-[8px] overflow-hidden">
      <div
        className="text-left lg:max-w-sm rounded-lg shadow p-5"
        style={{
          backgroundImage: `url(${CompanyNotFoundBg})`,
          backgroundSize: 'cover', // or try '100% 100%' if 'cover' still crops
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundColor: '#002940',
          width: '100%',
          height: '100%',
          imageRendering: 'auto', // prevents pixelation
        }}
      >
        <div className="w-full md:w-[221px]">
          <h4 className="mb-2 text-[32px] font-semibold tracking-tight text-white font-sans">
            Business Not Found?
          </h4>
          <p className="mb-3 font-light text-white text-f16 font-sans">
            Order a fresh report on a business now.
          </p>
          <button
            className="inline-flex items-center text-sm font-medium text-center"
            onClick={handleSwitch}
          >
            <Link
              to="/order-web-profile"
              state={{ prefill: { companyName: searchQuery, countryCode: countryData?.code } }}
            >
              <img src={ArrowNext} alt="arrow" />
            </Link>
          </button>
        </div>
      </div>
    </div>
  );
};
